import React from 'react'
import Link from 'next/link'
import Router from 'next/router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withI18next } from 'lib/i18n/withI18next'
import { prepareFAQ } from 'lib/api/prepared-faq'
import Typo from 'constants/typography'
import copy from '../outfit-shopping/copy'
import styles from './delivery-summary.scss'

const DeliverySummary = ({ product, country, language, t }) => {
  const preparePolicy = (type) => {
    prepareFAQ(type, country, language)
    // Warm route code only after intent, so it does not compete with PDP images.
    Router.prefetch(`/faq?type=${type}`).catch(() => {})
  }
  const returnsType = product.is_italist ? 'italist' : 'returns'
  return (
    <div className="pdp-delivery-summary">
      <style jsx>{styles}</style>
      <div>
        <p className={Typo.subtitle2}>{copy(t, language, 'delivery')}</p>
        <Link
          href="/faq?type=shipping"
          as={`/${country}/${language}/info/shipping`}
        >
          <a
            className={Typo.body2}
            onMouseEnter={() => preparePolicy('shipping')}
            onFocus={() => preparePolicy('shipping')}
            onTouchStart={() => preparePolicy('shipping')}
          >
            {copy(t, language, 'shippingPolicy')}
          </a>
        </Link>
      </div>
      <div>
        <p className={Typo.subtitle2}>{copy(t, language, 'returns')}</p>
        {!product.is_italist && typeof product.is_returnable === 'boolean' && (
          <p className={Typo.body2}>
            {copy(
              t,
              language,
              product.is_returnable ? 'eligible' : 'notReturnable',
            )}
          </p>
        )}
        <Link
          href={`/faq?type=${product.is_italist ? 'italist' : 'returns'}`}
          as={`/${country}/${language}/info/${
            product.is_italist ? 'italist' : 'returns'
          }`}
        >
          <a
            className={Typo.body2}
            onMouseEnter={() => preparePolicy(returnsType)}
            onFocus={() => preparePolicy(returnsType)}
            onTouchStart={() => preparePolicy(returnsType)}
          >
            {copy(t, language, 'returnsPolicy')}
          </a>
        </Link>
      </div>
    </div>
  )
}

DeliverySummary.propTypes = {
  product: PropTypes.shape({
    is_returnable: PropTypes.bool,
    is_italist: PropTypes.bool,
  }).isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}
export { DeliverySummary }
export default connect((state) => state.internationalization)(
  withI18next()(DeliverySummary),
)
